import { useWorkspace } from "@/context/WorkspaceContext";

export default function WorkspaceSwitcher() {
  const { workspace, setWorkspace } = useWorkspace();
  return (
    <div className="inline-flex rounded-full bg-slate-100 p-1" data-testid="workspace-switcher">
      {["amber", "berke"].map((w) => {
        const active = workspace === w;
        return (
          <button
            key={w}
            type="button"
            onClick={() => setWorkspace(w)}
            data-testid={`workspace-${w}`}
            className={`px-6 py-1.5 rounded-full text-sm font-semibold tracking-tight transition-colors duration-150 ${
              active ? "bg-emerald-800 text-white shadow-sm" : "text-slate-600 hover:text-slate-900"
            }`}
          >
            {w === "amber" ? "Amber" : "Berke"}
          </button>
        );
      })}
    </div>
  );
}
